import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { updateGlobalToastMessage } from "appRedux/slices/globalSlice"

type UseClipboardReturn = {
  copiedText: string | null;
  copyToClipboard: (text: string) => Promise<boolean>;
  isSupported: boolean;
};

export default function useCopyToClipboard(triggerReset?: any): UseClipboardReturn {
  const [copiedText, setCopiedText] = useState<string | null>(null)

  const dispatch = useDispatch()

  const isSupported = !!navigator?.clipboard

  useEffect(() => {
    setCopiedText(null)
  }, [triggerReset])

  const copyToClipboard = async (text: string): Promise<boolean> => {
    if (!isSupported) {
      console.warn("Clipboard not supported")
      return false
    }

    try {
      await navigator.clipboard.writeText(text)
      setCopiedText(text)
      dispatch(updateGlobalToastMessage({
        severity: "success",
        key: "copiedToClipboard",
        show: true,
        message: "general.linkCopiedSuccessfully"
      }))
      return true
    } catch (error) {
      console.error("Failed to copy text to clipboard:", error)
      dispatch(updateGlobalToastMessage({
        severity: "error",
        key: "copiedToClipboard",
        show: true,
        message: "general.serverError"
      }))
      return false
    }
  }

  return { copiedText, copyToClipboard, isSupported }
}
